import React from "react";
import CustomChart from "../../components/customChart/customChart";
import { LaunchTestContext } from "../../store/launchTestStore";
export default function ReactionSummary({
  totalScore,
  averageTimeSpend,
  correct1,
  correct2,
  incorrect1,
  incorrect2,
  omi1,
  omi2,
  com1,
  com2,
  quickTap1,
  quickTap2,
  tap1,
  tap2,
  totalTap,
  scoreHead1 = "Nothing",
  scoreHead2 = "",
  comingFrom,
  testName,
}) {
  const { launchTestC } = LaunchTestContext();
  const { launchTestData } = launchTestC;
  return (
    <>
      <div className="reaction-test-name">
        {launchTestData.data[0].section_name.toLowerCase()}
      </div>
      <div className="sum-dnb-total">
        <div className="sum-dnb-total__score">
          <h3>Score</h3>
          <span>{Math.sign(totalScore) === -1 ? 0 : totalScore}</span>
        </div>
        <div className="sum-dnb-total__time">
          <h3>Avg Time</h3>
          <span>{Math.floor(averageTimeSpend)} ms</span>
        </div>
      </div>
      <div className="sum-dnb-score">
        <div className="sum-dnb-score__stat">
          <h3>SCORE</h3>
          <p className="title">Correct</p>
          <p className="title">Incorrect</p>
          {comingFrom === "dnb" && <p className="title">Quick Tap</p>}
        </div>
        <div className="sum-dnb-score__pos">
          <h3
            style={{ visibility: comingFrom === "dnb" ? "initial" : "hidden" }}
          >
            {scoreHead1}
          </h3>
          <p>{correct1}</p>
          <p>{incorrect1}</p>
          {comingFrom === "dnb" && <p>{quickTap1}</p>}
        </div>
        {comingFrom === "dnb" && (
          <div className="sum-dnb-score__sound">
            <h3 className="title">{scoreHead2}</h3>
            <p>{correct2}</p>
            <p>{incorrect2}</p>
            <p>{quickTap2}</p>
          </div>
        )}
      </div>

      <div className="sum-dnb-error">
        <h3>Error Types</h3>
        <div
          className=""
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          <div className="" style={{ margin: 20 }}>
            <CustomChart
              omission={omi1}
              commission={com1}
              label1="Omission"
              label2="Commission"
              label3="Quick Tap"
            />
          </div>
          {comingFrom === "dnb" && (
            <div className="" style={{ margin: 20 }}>
              <CustomChart
                omission={omi2}
                commission={com2}
                quickTap={quickTap2}
                label1="Omission"
                label2="Commission"
              />
            </div>
          )}
        </div>
      </div>

      <div className={`sum-dnb-tap ${comingFrom !== "dnb" && "cpt"}`}>
        <div className={`sum-dnb-tap__total ${comingFrom !== "dnb" && "cpt"}`}>
          <p className="title">Total Tap</p>
          <p>{totalTap}</p>
        </div>

        {comingFrom !== "dnb" && (
          <div className="sum-dnb-tap__total cpt">
            <p className="title">Quick Tap</p>
            <p>{quickTap1}</p>
          </div>
        )}

        {comingFrom === "dnb" && (
          <>
            <div className="sum-dnb-tap__pos">
              <p className="title">{scoreHead1}</p>
              <p>{tap1}</p>
            </div>
            <div className="sum-dnb-tap__sound">
              <p className="title">{scoreHead2}</p>
              <p>{tap2}</p>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export const CRSRSum = ({
  accuracy,
  reactionTime,
  anticipatoryTap,
  correctTap,
  incorrectTap,
  earlyTap,
  lateTap,
  fastest,
  slowest,
}) => {
  const { launchTestC } = LaunchTestContext();
  const { launchTestData } = launchTestC;
  return (
    <>
      <div className="reaction-test-name">
        {launchTestData.data[0].section_name.toLowerCase()}
      </div>
      <div className="sum-dnb-total">
        <div className="sum-dnb-total__score">
          <h3>Accuracy</h3>
          <span>{accuracy}%</span>
        </div>
        <div className="sum-dnb-total__time">
          <h3>Reaction Time</h3>
          <span>{Math.floor(reactionTime)} ms</span>
        </div>
      </div>
      <div className="sum-dnb-score">
        <div className="sum-dnb-score__stat">
          <h3>SCORE</h3>
          <p className="title">Correct</p>
          <p className="title">Incorrect</p>
          <p className="title">Anticipatory Tap</p>
        </div>
        <div className="sum-dnb-score__pos">
          <h3 style={{ visibility: "hidden" }}>nothing</h3>
          <p>{correctTap}</p>
          <p>{incorrectTap}</p>
          <p>{anticipatoryTap}</p>
        </div>
      </div>
      <div className="sum-dnb-error">
        <h3>Error Types</h3>
        <div className="" style={{ display: "flex", flexWrap: "wrap" }}>
          <div className="" style={{ margin: "20px 0px" }}>
            <CustomChart
              // omission={incorrectTap}
              // commission={earlyTap}
              type="crsr"
              earlyTap={earlyTap}
              lateTap={lateTap}
              // label1="Incorrect Tap"
              label1="Early Tap"
              label2="Late Tap"
            />
          </div>
        </div>
      </div>
      <div className="sum-dnb-tap">
        <div className="sum-dnb-tap__total">
          <p className="title">Fastest</p>
          <p className="title">Slowest</p>
        </div>
        <div className="sum-dnb-tap__pos">
          <p>{fastest} ms</p>
          <p>{slowest} ms</p>
        </div>
      </div>
    </>
  );
};
